<template>
  <div>
    <DataTable :data-model="'templates.templatecategories'"
               :items="categories"
               :exclude-fields="['nameEn', 'description', 'descriptionEn', 'subcategory', 'parentCategory', 'references']"
               :permission-name="'Templates'"
               :allow-create="false"
               :allow-delete="false"
               :items-per-page="5"
               :loading="loading"
               :display-name-plural="$t('entities.TemplateCategory.Plural')"
               :display-name-singular="$t('entities.TemplateCategory.Singular')" />
    <DataTable :data-model="'templates.templatecategories'"
               :items="subcategories"
               :exclude-fields="['nameEn', 'description', 'descriptionEn', 'subcategory', 'references']"
               :permission-name="'Templates'"
               :allow-create="false"
               :allow-delete="false"
               :items-per-page="5"
               :loading="loading"
               :display-name-plural="$t('entities.TemplateSubcategory.Plural')"
               :display-name-singular="$t('entities.TemplateSubcategory.Singular')" />
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  name: 'ViewTemplateCategories',
  components: {
    DataTable
  },
  data() {
    return {
      categories: [],
      subcategories: [],
      loading: true
    };
  },
  created() {
    this.axios
      .get('/admin/templatecategories')
      .then((res) => {
        if (res.status === 200 && res.data.result.length > 0) {
          const itemsArr = res.data.result;
          this.categories = itemsArr.filter((x) => !x.subcategory);
          this.subcategories = itemsArr.filter((x) => x.subcategory);
        } else {
          this.categories = [];
          this.subcategories = [];
        }
        this.loading = false;
      })
      .catch((err) => Promise.reject(err));
  }
};
</script>
<style scoped></style>
